import { useQuery } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import api from '@/shared/api';
import handleHttpError from '@/shared/services/HandleHttpError';
// The first preview of a period collects all its registrations, which takes longer than the default timeout.
const PreviewTimeout = 5 * 60 * 1000;
export const useCapacityPlanningPreview = (period, mapping, enabled) => {
    const intl = useIntl();
    return useQuery(['CapacityPlanningPreview', period.startDate, period.endDate, mapping], ({ signal }) => api.base
        .post('/api/CapacityPlanning/Preview', mapping, {
        params: period,
        timeout: PreviewTimeout,
        signal,
    })
        .then(res => res.data), {
        enabled,
        keepPreviousData: true,
        refetchOnWindowFocus: false,
        retry: false,
        onError: (apiError) => {
            handleHttpError(intl)(apiError);
        },
    });
};
